import styled from '@emotion/styled';
import { Button, Modal } from 'antd';
import { Col, Row } from 'components';
import { theme } from 'configs/styled';
import React, { useState } from 'react';

export interface IPreviewButtonProps {
  title: string;
  url: string;
}

const ModalStyle = styled(Modal)`
  .ant-modal-title,
  .ant-modal-body {
    font-family: ${theme.fonts.NotoSansTh}, ${theme.fonts.NotoSands};
  }
`;

const PreviewButton: React.FC<IPreviewButtonProps> = props => {
  const { children, title, url } = props;
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleClickPreview = () => {
    setIsModalVisible(true);
  };

  const handleClickCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Button
        type="link"
        style={{
          display: 'flex',
          marginLeft: theme.spacing.xl,
          alignItems: 'center',
          position: 'absolute',
          left: '110px',
        }}
        onClick={handleClickPreview}
      >
        ดูรูปตัวอย่าง
      </Button>
      <ModalStyle
        title={title}
        visible={isModalVisible}
        onCancel={handleClickCancel}
        footer={null}
      >
        <Row
          justify="center"
          align="middle"
          style={{ marginBottom: theme.spacing.xl }}
        >
          <Col>
            <img
              alt={url}
              style={{
                height: '100%',
                width: 'auto',
                maxHeight: theme.elementSize.previewImageMaxHeight,
                maxWidth: theme.elementSize.previewImageMaxWidth,
                objectFit: 'contain',
              }}
              src={url}
            />
          </Col>
        </Row>
        {children}
      </ModalStyle>
    </>
  );
};

export default PreviewButton;
